import React from 'react';
import PropTypes from 'prop-types';

const BrySwitch = ({ checked, onChange, label, disabled = false }) => {
  return (
    <label className={`flex items-center gap-3 cursor-pointer ${disabled ? 'opacity-50 cursor-not-allowed' : ''}`}>
      <div className="relative">
        <input 
          type="checkbox" 
          className="sr-only" 
          checked={checked} 
          onChange={(e) => !disabled && onChange(e.target.checked)}
          disabled={disabled}
          aria-checked={checked}
        />
        {/* Track */}
        <div 
          className={`block w-12 h-6 rounded-full transition-colors duration-300 ease-in-out ${
            checked ? 'bg-[var(--bry-accent)]' : 'bg-gray-700'
          }`}
        ></div>
        {/* Dot */}
        <div 
          className={`absolute left-1 top-1 bg-white w-4 h-4 rounded-full transition-transform duration-300 ease-in-out ${
            checked ? 'transform translate-x-6' : ''
          }`}
        ></div>
      </div>
      {label && (
        <span className="text-sm font-medium text-gray-300 select-none">
          {label}
        </span>
      )}
    </label>
  );
};

BrySwitch.propTypes = {
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string,
  disabled: PropTypes.bool
};

export default BrySwitch;
